/**
 * 销售业绩成本/利润核算可见角色：超管、管理员、财务
 */
export function canViewSaleCostProfit(userRole) {
  return ['super_admin', 'admin', 'finance'].includes(userRole)
}
